module.exports = {"failed":"Login failed","success":"Login successful"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/auth.json
// module id = 2782
// module chunks = 31